// extracted by mini-css-extract-plugin
export default {"modalWrap":"Modal_modalWrap__gtcI4","modal_content":"Modal_modal_content__Hgy4i","set":"Modal_set__nIKZN"};